"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = require("@insided/shared/services/logger");

var _axios = _interopRequireDefault(require("axios"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UserContext = require("@insided/shared/services/UserContext");

var _StickyFlag = _interopRequireDefault(require("@insided/destination/icons/StickyFlag"));

var _contentType = require("@insided/shared/utils/contentType");

var _TopicHeader = _interopRequireDefault(require("./TopicHeader"));

var _TopicInfo = _interopRequireDefault(require("./TopicInfo"));

var _getCssVariables = require("@insided/shared/utils/getCssVariables");

var _BrandConfigContext = require("@insided/shared/services/BrandConfigContext");

var _TopicListItemCard = _interopRequireDefault(require("./TopicListItemCard"));

var _index = require("../TopicView/index.sync");

var _utils = require("./utils");

var _topicService = require("@insided/shared/services/topicService");

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _common = require("@insided/shared/utils/common");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'topic-list-item';
exports.cssAnchorName = cssAnchorName;

var TopicListItem = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicListItem, _Component);

  var _super = _createSuper(TopicListItem);

  function TopicListItem(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TopicListItem);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isUsingCardTheme: false,
      // Default state for SSR
      showMarkAsSpamModal: false,
      showTrashModal: false,
      alert: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ref", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFavoriteRemoval", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var params;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = new URLSearchParams();
              params.append('threadid', _this.props.topic.publicId);
              _context.next = 4;
              return _axios.default.post('/favorite/delete', params.toString());

            case 4:
              if (_this.ref) {
                _this.ref.classList.add('remove-favorite');

                setTimeout(function () {
                  if (_this.ref) {
                    var _this$ref$parentNode, _this$ref$parentNode$;

                    (_this$ref$parentNode = _this.ref.parentNode) === null || _this$ref$parentNode === void 0 ? void 0 : (_this$ref$parentNode$ = _this$ref$parentNode.parentNode) === null || _this$ref$parentNode$ === void 0 ? void 0 : _this$ref$parentNode$.removeChild(_this.ref.parentNode); // Remove `date-preact` component
                  }
                }, 250);
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateIsUsingCardTheme", function (event) {
      var isUsingCardTheme = _this.state.isUsingCardTheme;
      var themeConfigurationEvent = event;
      var themeConfiguration = themeConfigurationEvent.detail.data;
      var updatedIsUsingCardTheme = themeConfiguration['--config-list-views-use-card-theme'] === '1';

      if (isUsingCardTheme !== updatedIsUsingCardTheme) {
        _this.setState({
          isUsingCardTheme: updatedIsUsingCardTheme
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showMarkAsSpamModal", function (show) {
      _this.setState({
        showMarkAsSpamModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showTrashModal", function (show) {
      _this.setState({
        showTrashModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleShowAlert", function (type, message) {
      _this.setState({
        alert: {
          type: type,
          message: typeof message === 'string' ? (0, _preact.h)(_phrase.default, {
            p: message
          }) : message !== null && message !== void 0 ? message : (0, _preact.h)(_phrase.default, {
            p: "topic_view.reported_content_modal.error"
          })
        }
      });
    });
    _this.ref = null;
    return _this;
  }

  (0, _createClass2.default)(TopicListItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (typeof window !== 'undefined') {
        this.setState({
          isUsingCardTheme: (0, _getCssVariables.getCssVariables)()['config-list-views-use-card-theme'] === '1'
        });
        window.addEventListener(_BrandConfigContext.BRAND_CONFIG_UPDATE_EVENT, this.updateIsUsingCardTheme);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined') {
        window.removeEventListener(_BrandConfigContext.BRAND_CONFIG_UPDATE_EVENT, this.updateIsUsingCardTheme);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          topic = _this$props.topic,
          attachmentCdn = _this$props.attachmentCdn,
          hideCategoryMetadata = _this$props.hideCategoryMetadata,
          clickCallback = _this$props.clickCallback,
          showUnsubscribeBtn = _this$props.showUnsubscribeBtn,
          ariaKey = _this$props.ariaKey,
          authors = _this$props.authors,
          isFrontendModerationEnabled = _this$props.isFrontendModerationEnabled,
          forceListView = _this$props.forceListView;
      var _this$state = this.state,
          isUsingCardTheme = _this$state.isUsingCardTheme,
          showMarkAsSpamModal = _this$state.showMarkAsSpamModal,
          showTrashModal = _this$state.showTrashModal,
          alert = _this$state.alert;
      var author = topic.author,
          contentType = topic.contentType,
          sticky = topic.sticky,
          publicId = topic.publicId,
          privateId = topic.privateId,
          categoryName = topic.categoryName,
          categoryUrl = topic.categoryUrl,
          isNew = topic.isNew,
          lastContributor = topic.lastContributor,
          isUnreadPostCountEnabled = topic.isUnreadPostCountEnabled,
          closed = topic.closed;
      var defaultAuthor = {
        id: '',
        name: 'Anonymous',
        avatar: ''
      };

      var _ref2 = authors[author === null || author === void 0 ? void 0 : author.id] || {},
          userTitle = _ref2.userTitle;

      if (isUsingCardTheme && !forceListView) {
        return (0, _preact.h)(_TopicListItemCard.default, {
          authors: authors,
          hideCategoryMetadata: hideCategoryMetadata,
          showUnsubscribeBtn: showUnsubscribeBtn,
          topic: topic,
          attachmentCdn: attachmentCdn,
          clickCallback: clickCallback,
          handleFavoriteRemoval: this.handleFavoriteRemoval,
          isUnreadPostCountEnabled: isUnreadPostCountEnabled,
          isNew: isNew
        });
      }

      var isBugContentTypeEnabled = _common.common.isModuleActive('bugContentType');

      return (0, _preact.h)(_UserContext.CurrentUserContext.Consumer, null, function (user) {
        var _authors$author$id, _authors$lastContribu;

        return (0, _preact.h)("div", {
          className: (0, _classnames.default)('qa-topic-block', 'topic-view', 'js-thread', "js-thread-id-".concat(publicId), {
            'topic-view--unread': isUnreadPostCountEnabled && isNew,
            'topic-view--sticky': sticky,
            'topic-view--ideation': contentType === 'idea',
            'topic-view--bug': isBugContentTypeEnabled && contentType === 'conversation'
          }),
          ref: function ref(_ref5) {
            _this2.ref = _ref5;
          }
        }, isFrontendModerationEnabled ? (0, _preact.h)("div", {
          className: "topic-view__action-bar"
        }, sticky && (0, _preact.h)(_StickyFlag.default, {
          className: "topic-view_sticky-flag",
          height: 24,
          width: 24,
          viewBox: "0 0 24 24"
        }), (0, _preact.h)(_index.PostActionsDropdown, {
          menuOptions: (0, _utils.extraMenuItems)({
            privateId: privateId,
            contentType: (0, _contentType.getConsistentContentType)(contentType),
            isSticky: sticky,
            isClosed: closed,
            onShowAlert: _this2.handleShowAlert,
            showMarkAsSpamModal: _this2.showMarkAsSpamModal,
            showTrashModal: _this2.showTrashModal
          })
        })) : sticky && (0, _preact.h)(_StickyFlag.default, {
          className: "topic-view_sticky-flag"
        }), (0, _preact.h)(_TopicHeader.default, {
          contentType: contentType,
          user: (_authors$author$id = authors[author === null || author === void 0 ? void 0 : author.id]) !== null && _authors$author$id !== void 0 ? _authors$author$id : defaultAuthor,
          userTitle: userTitle,
          hideCategoryMetadata: hideCategoryMetadata,
          categoryUrl: categoryUrl,
          categoryName: categoryName
        }), (0, _preact.h)(_TopicInfo.default, {
          topic: topic,
          lastContributor: (_authors$lastContribu = authors[lastContributor.id]) !== null && _authors$lastContribu !== void 0 ? _authors$lastContribu : defaultAuthor,
          showUnsubscribeBtn: showUnsubscribeBtn,
          userId: user.id,
          attachmentCdn: attachmentCdn,
          clickCallback: clickCallback,
          ariaKey: ariaKey,
          handleFavoriteRemoval: _this2.handleFavoriteRemoval
        }), showMarkAsSpamModal && (0, _preact.h)(_index.MarkAsSpamModal, {
          title: "frontend_moderation.mark_topic_as_spam",
          subTitle: "frontend_moderation.spam_topic_warning",
          isOpen: showMarkAsSpamModal,
          onClose: function onClose() {
            return _this2.showMarkAsSpamModal(false);
          },
          onMarkAsSpam: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
            return _regenerator.default.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _topicService.markTopicAsSpam)((0, _contentType.getConsistentContentType)(contentType), topic.privateId);

                  case 3:
                    _this2.handleShowAlert('success', (0, _preact.h)(_phrase.default, {
                      p: "frontend_moderation.topic_marked_as_spam"
                    }));

                    _this2.showMarkAsSpamModal(false);

                    window.location.reload();
                    _context2.next = 12;
                    break;

                  case 8:
                    _context2.prev = 8;
                    _context2.t0 = _context2["catch"](0);

                    _logger.logger.error(_context2.t0, {
                      component: 'TopicListItem',
                      action: 'markAsSpam'
                    });

                    _this2.handleShowAlert('error', (0, _preact.h)(_phrase.default, {
                      p: "frontend_moderation.error_while_marking_topic_as_spam"
                    }));

                  case 12:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, null, [[0, 8]]);
          }))
        }), showTrashModal && (0, _preact.h)(_index.TrashModal, {
          title: "frontend_moderation.trash_the_topic",
          subTitle: "frontend_moderation.trash_topic_warning",
          isOpen: showTrashModal,
          onClose: function onClose() {
            return _this2.showTrashModal(false);
          },
          onTrash: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
            return _regenerator.default.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _topicService.toggleTrashed)((0, _contentType.getConsistentContentType)(contentType), topic.privateId, true);

                  case 3:
                    _this2.handleShowAlert('success', (0, _preact.h)(_phrase.default, {
                      p: "frontend_moderation.topic_trashed"
                    }));

                    _this2.showTrashModal(false);

                    window.location.reload();
                    _context3.next = 12;
                    break;

                  case 8:
                    _context3.prev = 8;
                    _context3.t0 = _context3["catch"](0);

                    _logger.logger.error(_context3.t0, {
                      component: 'TopicListItem',
                      action: 'toggleTrashed'
                    });

                    _this2.handleShowAlert('error', (0, _preact.h)(_phrase.default, {
                      p: "frontend_moderation.error_while_trashing_reply"
                    }));

                  case 12:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, null, [[0, 8]]);
          }))
        }), (alert === null || alert === void 0 ? void 0 : alert.message) && (0, _preact.h)(_AlertComponent.default, {
          sticky: true,
          messageType: alert.type,
          isVisibleFor: 3000,
          onTimeoutEnd: function onTimeoutEnd() {
            return _this2.setState({
              alert: undefined
            });
          }
        }, alert.message));
      });
    }
  }]);
  return TopicListItem;
}(_preact.Component);

var _default = TopicListItem;
exports.default = _default;